export const baseSpacing = {
  sp_4: 4,
  sp_8: 8,
  sp_10: 10,
  sp_12: 12,
  sp_16: 16,
  sp_24: 24,
  sp_32: 32,
  sp_56: 56,
} as const;

export type SpacingToken = keyof typeof baseSpacing;
export type SpacingValue = typeof baseSpacing[SpacingToken];
